import { toast } from 'react-toastify';

export default async function changePermissions(baseQuery, { body, path }) {
  const res = await baseQuery({
    url: `${path}/change_permissions.json`,
    method: 'POST',
    body: { change: body },
  });

  const { response } = res.meta;

  if (!response.ok) {
    toast.error('There was a problem processing your request');
    throw new Error(`${response.status} Error: ${res.error.error}`);
  }

  return response;
}
